<template>
  <v-card
    v-if="formatted"
    :flat="compact"
    color="transparent"
    class="hyp-details-list-item-style"
    :class="{
      'white--text': isDarkTheme,
      'hyp-article-is-read': isRead,
    }"
  >
    <div style="display: none;">{{ isTwitter }}</div>
    <v-row>
      <v-col class="hyp-details-list-item-flex-wrapper col-12">
        <div
          v-if="!listView && !isThumbsDown && !verifiedEvent"
          @click="toggle()"
        >
          <v-img
            v-if="showImage && img && !imgFailed"
            width="115px"
            :height="imgHeightStyle"
            class="hyp-details-list-item-img mr-3"
            alt="article image"
            :src="img"
            @error="onImgError"
          ></v-img>
          <div v-else-if="isTwitter" style="display: none;">
            If no image and isTwitter than dont show a placeholder
          </div>
          <v-img
            v-else
            width="115px"
            :height="imgHeightStyle"
            class="hyp-details-list-item-img mr-3"
            alt="article placeholder"
            :src="placeholderImg"
          ></v-img>
        </div>

        <div class="hyp-details-list-item-container px-2">
          <div
            class="body-2 pt-2 hyp-details-list-item-title-container"
            :style="titleContainerHeight"
          >
            <span
              @click="toggle()"
              class="pull-left application-heading"
              :class="{
                'hyp-details-list-item-title': !listView,
                'hyp-details-list-item-title-list-view': listView,
                'hyp-details-list-item-title-compact': compact,
                'hyp-details-list-item-title-thumbs-down': isThumbsDown,
              }"
              :style="titleColor"
              :title="title"
            >
              <v-icon
                v-if="item.highlight"
                size="10"
                color="blue"
                class="mr-1 hyp-details-list-item-highlight"
                title="Selected notification content"
                >fas fa-circle</v-icon
              >
              {{ title }}
            </span>

            <div class="clearfix"></div>
          </div>
          <div
            v-if="
              !compact ||
              !isThumbsDown ||
              ((compact || isThumbsDown) && readMore)
            "
            @click="toggle()"
            class="caption hyp-details-list-item-summary"
            :class="{
              'hyp-details-list-item-summary-no-read-more': !readMore,
              'my-1': !compact || readMore,
            }"
            :style="summaryContainerHeight"
          >
            <div v-if="compact || (isThumbsDown && !verifiedEvent)">
              <v-img
                v-if="img && !imgFailed && readMore"
                width="115px"
                :height="imgHeightStyle"
                class="hyp-details-list-item-img-compact mr-2"
                alt="article image"
                :src="img"
                @error="onImgError"
              ></v-img>
              <div v-else-if="isTwitter" style="display: none;">
                If no image and isTwitter than dont show a placeholder
              </div>
              <v-img
                v-else
                width="115px"
                :height="imgHeightStyle"
                class="hyp-details-list-item-img-compact mr-2"
                alt="article placeholder"
                :src="placeholderImg"
              ></v-img>
            </div>

            <div style="line-height: 19px;">{{ summary }}</div>
          </div>
          <div
            v-if="(compact || !readMore) && !isThumbsDown"
            @click="toggle()"
            class="pt-0"
          >
            <v-row
              v-if="typeof sentiment === 'number' || topic"
              class="mt-0 mb-0 pb-0 pt-0"
              align="baseline"
              :class="listView ? 'mt-0 mb-0 pb-0 pt-1' : 'mt-0 mb-0 pb-0 pt-0'"
            >
              <v-col
                xs12
                class="mt-0 mb-0 pb-0 pt-0 text-left hyp-details-list-item-sentiment"
              >
                <DetailsListItemExtras
                  :sentiment="sentiment"
                  :emotions="emotions"
                  :reliability="reliability"
                  :topicsDisplayList="topic"
                  :lineBreaks="!listView"
                />
              </v-col>
            </v-row>
            <v-row align="baseline" class="mt-1">
              <v-col xs12 class="text-left pb-0 pt-0 hyp-details-row-footer">
                <div class="hyp-details-list-item-date pull-left mr-2">
                  {{ dateTime }}
                </div>
                <a
                  @click.stop.prevent="openSource(formatted.link)"
                  :href="formatted.link"
                  class="hyp-details-list-item-read-more pull-left mr-1"
                  >{{ source }}</a
                >

                <DetailsActionIcons
                  :item="item"
                  :show-thumbs-down="false"
                  :show-thumbs-down-geo="false"
                  :show-primary-topics="showPrimaryTopics"
                  :primary-topic="primaryTopic"
                  :showing-alerts="true"
                  theme="light"
                  :show-read-icon="actionIconsEnabled"
                  :show-translate-icon="showTranslateIcon"
                  :translating="translating"
                  :translate-hint="translateHint"
                  :read-hint="readHint"
                  :show-copy-icon="false"
                  @click-read="handleReadClick"
                  @click-translate="translate"
                  class="pull-left"
                ></DetailsActionIcons>

                <div class="clearfix"></div>
              </v-col>
            </v-row>
          </div>
          <div v-if="!compact && readMore" class="pt-0">
            <v-row v-if="topic" class="mt-0 mb-0 pb-0 pt-0" align="baseline">
              <v-col
                xs12
                class="mt-0 mb-0 pb-0 pt-0 text-left hyp-details-list-item-topics"
              >
                <span class="application-heading">Events</span>: {{ topic }}
              </v-col>
            </v-row>
            <v-row
              v-if="verifiedEvent"
              class="mt-0 mb-0 pb-0 pt-0"
              align="baseline"
            >
              <v-col
                xs12
                class="mt-0 mb-0 pb-0 pt-0 text-left hyp-details-list-item-topics"
              >
                <span class="application-heading">Categories</span>:
                {{ categories }}
              </v-col>
            </v-row>
            <v-row
              v-if="typeof sentiment === 'number'"
              class="mt-0 mb-0 pb-0 pt-1"
              align="baseline"
            >
              <v-col
                xs12
                class="mt-0 mb-0 pb-0 pt-0 text-left hyp-details-list-item-sentiment"
              >
                <DetailsListItemExtras
                  :sentiment="sentiment"
                  :emotions="emotions"
                  :reliability="reliability"
                  :plainText="true"
                />
              </v-col>
            </v-row>
            <v-row align="baseline">
              <v-col xs12 @click="toggle()" class="text-left pt-0 mt-0">
                <div class="hyp-details-list-item-date pull-left mr-1">
                  {{ dateTime }}
                </div>
                <a
                  @click.stop.prevent="openSource(formatted.link)"
                  :href="formatted.link"
                  class="hyp-details-list-item-read-more pull-left mr-1"
                  >{{ source }}</a
                >

                <DetailsActionIcons
                  :item="item"
                  :show-thumbs-down="false"
                  :show-thumbs-down-geo="false"
                  :show-primary-topics="showPrimaryTopics"
                  :showing-alerts="true"
                  theme="light"
                  :show-read-icon="actionIconsEnabled"
                  :show-translate-icon="showTranslateIcon"
                  :translating="translating"
                  :translate-hint="translateHint"
                  :read-hint="readHint"
                  :show-copy-icon="false"
                  @click-read="handleReadClick"
                  @click-translate="translate"
                  class="pull-left"
                ></DetailsActionIcons>

                <div class="clearfix"></div>
              </v-col>
            </v-row>
          </div>
        </div>
        <LeaveAppPopup
          :link="sourceLink"
          :show="showSourceLink"
        ></LeaveAppPopup>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import lodashGet from "lodash/get";
import lodashHas from "lodash/has";

import { mapGetters } from "vuex";

import { MODULE_PREFIX_USER, MODULE_PREFIX_HOME } from "@/store";
import { GET_PREFERENCES } from "@/store/actions.type";
import { EVENTS_DISASTERS_TYPES } from "@/common/constants/events";
import { ICONS } from "@/common/constants/icons";
import { getFormatted } from "@/common/date.utilities";
import { translate } from "@/services/common/translator.service";
import {
  isAdmin,
  hasArticleHideImageAccess,
} from "@/services/user/user.service";
import {
  getTopicsStringFromTopicsScores,
  getPrimaryTopics,
} from "@/services/events/topics.service";

import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

const EMITTED_ACTIONS = {
  READ_CLICK: "read-click",
  UNREAD_CLICK: "unread-click",
  DELETE_CLICK: "delete-click",
};

export default {
  name: "DetailsListItem",
  components: {
    LeaveAppPopup: () => import("@/components/common/LeaveAppPopup"),
    DetailsActionIcons: () =>
      import("@/components/common/details/DetailsActionIcons"),
    DetailsListItemExtras: () =>
      import("@/components/common/details/DetailsListItemExtras"),
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    listView: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      required: false,
    },
    translation: {
      type: Boolean,
      default: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    actionIconsEnabled: {
      type: Boolean,
      default: false,
    },
    showPrimaryTopics: {
      type: Boolean,
      default: false,
    },
    primaryTopic: {
      type: Array,
    },
  },
  data: () => ({
    imgFailed: true,
    readMore: false,
    isRead: false,
    translated: false,
    translating: false,
    title: null,
    summary: null,
    source: null,
    srcLanguage: null,
    topic: null,
    isThumbsDown: false,
    sourceLink: null,
    showSourceLink: null,
  }),
  computed: {
    ...mapGetters({
      preferences: MODULE_PREFIX_USER + "preferences",
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
    }),
    type() {
      if (this.detailsSidebar && this.detailsSidebar.type) {
        if (
          this.detailsSidebar.type === "monitor" &&
          this.detailsSidebar.monitorType
        ) {
          return this.detailsSidebar.monitorType;
        }
        return this.detailsSidebar.type;
      }
      return null;
    },
    formatted() {
      if (this.item.properties && this.item.properties.formatted) {
        let formatted = this.item.properties.formatted;
        if (typeof formatted === "string" || formatted instanceof String) {
          formatted = JSON.parse(formatted);
        }
        this.setTitle(formatted.title);
        this.setSummary(formatted.summary);
        this.setSource(formatted.source);
        this.setSrcLanguage(formatted.language);
        this.setTopic(formatted.topic_scores);
        this.setIsRead(formatted.read);
        return formatted;
      }
      return null;
    },
    isTwitter() {
      if (lodashGet(this.formatted, "source")) {
        if (this.formatted.source.toLowerCase().indexOf("twitter") > -1) {
          if (this.compact) {
            this.setReadMore(true);
          }
          return true;
        }
      }
      return false;
    },
    verifiedEvent() {
      return this.formatted.type === "verifiedEvent";
    },
    categories() {
      if (this.formatted.categories) {
        const categories = [];
        this.formatted.categories.forEach((cat) => {
          if (cat.name) {
            categories.push(cat.name);
          }
        });
        return categories.join();
      }
      return null;
    },
    placeholderImg() {
      let placeholder = "no_data_seerist.png";
      if (this.formatted && this.formatted.type) {
        if (this.formatted.type === EVENTS_DISASTERS_TYPES.floods) {
          placeholder = "no_data_flood.png";
        } else if (this.formatted.type === EVENTS_DISASTERS_TYPES.earthquakes) {
          placeholder = "no_data_earthquake.png";
        } else if (this.formatted.type === EVENTS_DISASTERS_TYPES.volcanoes) {
          placeholder = "no_data_volcano.png";
        }
      }
      return require(`@/assets/images/placeholders/${placeholder}`);
    },
    dateTime() {
      if (this.listView || this.readMore) {
        if (this.formatted && this.formatted.occurred) {
          return getFormatted(this.formatted.occurred);
        }
      }
      if (this.formatted && this.formatted.occurred) {
        return getFormatted(this.formatted.occurred);
      }
      return null;
    },
    showImage() {
      return !hasArticleHideImageAccess();
    },
    img() {
      if (this.formatted.img) {
        this.setImgFailed(false);
        return this.formatted.img;
      }
      return null;
    },
    userLanguage() {
      const LANG = lodashGet(this.preferences, "language.autoTranslateDest");
      return LANG && LANG.value ? LANG.value : "en";
    },
    languageIcon() {
      if (this.theme && this.theme === "light") {
        const ICON = ICONS.misc.language.active;
        return require(`@/assets/images${ICON}`);
      } else {
        const ICON = ICONS.misc.language.inactive;
        return require(`@/assets/images${ICON}`);
      }
    },
    languageMatches() {
      return !!(
        this.srcLanguage &&
        this.userLanguage &&
        this.userLanguage.toLowerCase() === this.srcLanguage.toLowerCase()
      );
    },
    showTranslateIcon() {
      if (this.userLanguage) {
        if (
          this.srcLanguage &&
          this.srcLanguage.toLowerCase() === "en" &&
          this.userLanguage.toLowerCase() === "en"
        ) {
          return false;
        }
        if (
          lodashGet(this.formatted, "translated") &&
          this.userLanguage.toLowerCase() === "en"
        ) {
          return false;
        }
      }
      return true;
    },
    translateHint() {
      if (lodashGet(this.preferences, "language.autoTranslateDest.name")) {
        return `Translate to ${lodashGet(
          this.preferences,
          "language.autoTranslateDest.name"
        )}`;
      } else {
        return `Translate to English`;
      }
    },
    adminInfo() {
      if (isAdmin() && lodashGet(this.formatted, "adminInfo")) {
        return this.formatted.adminInfo;
      }
      return null;
    },
    adminInfoStyle() {
      if (this.hasFeedbackLoopFeature) {
        return {
          "margin-left": "10px",
        };
      }
      return {};
    },
    esId() {
      if (isAdmin() && lodashGet(this.formatted, "esId")) {
        return this.formatted.esId;
      }
      return null;
    },
    documentId() {
      if (lodashGet(this.formatted, "documentId")) {
        return this.formatted.documentId;
      }
      return null;
    },
    imgHeightStyle() {
      return "107px";
    },
    titleColor() {
      if (this.theme && this.theme === "light") {
        return {
          color: "black",
        };
      }
      return {
        color: "white",
      };
    },
    titleContainerHeight() {
      if (this.verifiedEvent) {
        return {
          "max-height": "30px",
        };
      }
      if (this.compact) {
        return {
          "max-height": "48px",
        };
      }
      let height = "48px";
      if (this.listView || this.isThumbsDown) {
        height = "28px";
      }
      return {
        height: height,
      };
    },
    summaryContainerHeight() {
      let height = "60px";
      if (this.listView) {
        height = "36px";
      }
      if (!this.readMore) {
        if (this.isThumbsDown || this.compact) {
          height = "0";
        }
        return {
          height: height,
        };
      }
      return {
        "min-height": height,
      };
    },
    hasFeedbackLoopFeature() {
      if (this.detailsSidebar) {
        let exists = false;
        if (this.detailsSidebar.type) {
          const PRIMARY_TOPICS = getPrimaryTopics();
          PRIMARY_TOPICS.forEach((topic) => {
            if (
              topic.type !== "travel" &&
              topic.type === this.detailsSidebar.type
            ) {
              exists = true;
            }
          });
        }
        if (
          this.detailsSidebar.monitorType &&
          this.detailsSidebar.monitorType === "hotspots"
        ) {
          exists = true;
        }
        return exists;
      }
      return false;
    },
    isDarkTheme() {
      if (this.theme === "light") {
        return false;
      }
      return true;
    },
    readHint() {
      if (this.isRead) {
        return "Mark as unread";
      }
      return "Mark as read";
    },
    sentiment() {
      if (lodashHas(this.item, "properties.scores.tone")) {
        return this.item.properties.scores.tone;
      }
      if (lodashHas(this.item, "properties.formatted.sentiment")) {
        return this.item.properties.formatted.sentiment;
      }
      return null;
    },
    emotions() {
      return this.item?.properties?.emotions || [];
    },
    reliability() {
      return (
        this.item?.properties?.formatted?.source_metadata?.reliability || null
      );
    },
  },
  mounted() {
    this.getPrefs();
  },
  methods: {
    toggle() {
      if (!this.isTwitter || (this.isTwitter && !this.compact)) {
        this.readMore = !this.readMore;
        if (this.readMore) {
          this.handlePageTrackerEvent(
            EVENT_CATEGORIES.alerted_content,
            EVENT_ACTIONS.clicked,
            "Explore Content - Article"
          );
        }
      }
    },
    getPrefs() {
      this.$store.dispatch(MODULE_PREFIX_USER + GET_PREFERENCES);
    },
    async translate() {
      this.translating = true;
      if (!this.translated) {
        const ORIGINAL_TEXT = [this.title, this.summary];
        let translatedText = await this.translateText(ORIGINAL_TEXT);
        if (
          translatedText &&
          Array.isArray(translatedText) &&
          translatedText.length
        ) {
          if (translatedText[0]) {
            this.setTitle(translatedText[0]);
          }
          if (translatedText[1]) {
            this.setSummary(translatedText[1]);
          }
        }
        this.translated = true;
        this.translating = false;
      } else {
        this.setTitle(this.formatted.title);
        this.setSummary(this.formatted.summary);
        this.translated = false;
        this.translating = false;
      }
    },
    async translateText(textArr) {
      let params = {
        text: textArr,
        dest: "en",
      };
      if (lodashGet(this.preferences, "language.autoTranslateDest.value")) {
        params.dest = lodashGet(
          this.preferences,
          "language.autoTranslateDest.value"
        );
      }

      const RESULT = await translate(params);
      if (RESULT && Array.isArray(RESULT) && RESULT.length) {
        let results = [];
        RESULT.forEach((item) => {
          if (item && item.translatedText) {
            results.push(item.translatedText);
          }
        });
        return results;
      }
      return null;
    },
    onImgError() {
      this.setImgFailed(true);
    },
    setImgFailed(value) {
      this.imgFailed = value;
    },
    setTitle(value) {
      this.title = value;
    },
    setSummary(value) {
      this.summary = value;
    },
    setSrcLanguage(value) {
      this.srcLanguage = value;
    },
    setSource(value) {
      this.source = value ? value.substring(0, 20) : "";
    },
    setReadMore(value) {
      this.readMore = value;
    },
    setIsRead(value) {
      this.isRead = value;
    },
    setTopic(obj) {
      this.topic = null;
      if (obj) {
        this.topic = getTopicsStringFromTopicsScores(obj, "cluster");
      }
    },
    handleAdminInfoClick() {
      if (this.esId) {
        console.log("ESID:", this.esId);
      }
    },
    handleThumbsDown(params) {
      this.readMore = false;
      this.isThumbsDown = params.value;
    },
    handleReadClick() {
      this.setIsRead(!this.isRead);
      if (this.isRead) {
        this.$emit(EMITTED_ACTIONS.READ_CLICK, this.documentId);
      } else {
        this.$emit(EMITTED_ACTIONS.UNREAD_CLICK, this.documentId);
      }
    },
    handleDeleteClick() {
      this.$emit(EMITTED_ACTIONS.DELETE_CLICK, this.documentId);
    },
    openSource(url) {
      this.sourceLink = url;
      this.showSourceLink = new Date().toISOString();
    },
  },
  beforeDestroy() {
    this.title = null;
    this.summary = null;
    this.source = null;
    this.srcLanguage = null;
    this.topic = null;
    this.sourceLink = null;
    this.showSourceLink = null;
    this.isRead = null;
  },
};
</script>

<style scoped>
.hyp-details-list-item-img {
  width: 107px;
  border-top-left-radius: 9px !important;
  float: left;
  cursor: pointer;
}
.hyp-details-list-item-img-compact {
  width: 107px;
  float: left;
  cursor: pointer;
}
a {
  text-decoration: none;
}
.hyp-details-list-item-container {
  width: 100%;
  text-align: left;
}
.hyp-details-list-item-title-container {
  overflow: hidden;
}
.hyp-details-list-item-style {
  border: 1px solid white;
  border-radius: 9px;
}
.hyp-details-list-item-title {
  cursor: pointer;
}
.hyp-details-list-item-title-list-view {
  cursor: pointer;
}
.hyp-details-list-item-title-thumbs-down {
  width: 275px;
  color: gray !important;
}
.hyp-details-list-item-title-compact {
  width: 85%;
  cursor: pointer;
}
.hyp-details-list-item-language {
  cursor: pointer;
}
.hyp-details-list-item-language-compact {
  position: relative;
  top: 5px;
}
.hyp-details-list-helper-icons {
  position: relative;
  top: 3px;
}
.hyp-details-list-item-admin-info {
  cursor: pointer;
  position: relative;
  top: -3px;
}
.hyp-details-list-item-feedback-loop {
  cursor: pointer;
}
.hyp-details-list-item-summary {
  overflow-wrap: break-word;
  word-wrap: break-word;
  cursor: pointer;
}
.hyp-details-list-item-summary-no-read-more {
  overflow: hidden;
}
.hyp-details-list-item-source-link-container {
  width: 100%;
}
.hyp-details-list-item-sentiment,
.hyp-details-list-item-topics {
  font-size: 10px;
  line-height: 1.6em;
}
.hyp-details-row-footer {
  position: relative;
  top: -8px;
}
.hyp-details-list-item-date {
  font-size: 10px;
}
.hyp-details-list-item-read-more {
  font-size: 10px;
  overflow: hidden;
  white-space: nowrap;
}
.hyp-details-list-item-translate {
  font-size: 10px;
}
.hyp-details-list-item-highlight {
  position: relative;
  top: -3px;
}
.hyp-translated-circle {
  font-size: 6px;
  position: relative;
  top: 8px;
  color: black;
}
.hyp-item-read-icon {
  cursor: pointer;
}
.hyp-article-is-read {
  opacity: 0.5;
}
.hyp-tree-pop-up {
  position: relative;
  top: -3px;
}
</style>
